import { GraniteButton } from 'components/V2/Button/GraniteButton';
import { Business, ConstructSharp, Wifi } from 'react-ionicons';
import { ReactComponent as Footsteps } from '../../assets/icon/footsteps.svg';
import { useNavigate } from 'react-router-dom';
import { useInventoryAccount } from './InventoryAccountContext';

const LocationHeader = () => {
  const { setMode } = useInventoryAccount();
  const navigate = useNavigate();
  return (
    <div className="mb-8 mt-12 flex justify-between gap-2 rounded bg-blue-800 px-6 py-7 shadow-elevation1">
      <div className="flex items-center gap-4 text-white">
        <Business color="currentColor" width="24px" height="24px" />
        <p className="text-xl font-bold">456 Oak Avenue, Afton, ME 22344</p>
      </div>
      <div className="flex gap-4">
        <GraniteButton
          variant="secondary"
          size="large"
          onClick={() =>
            navigate('/access-express/open-quote/add-configurations')
          }
        >
          <Wifi width="24px" height="24px" />
          Order services
        </GraniteButton>
        <GraniteButton
          variant="secondary"
          size="large"
          onClick={() => navigate('/tech-express/let-us-help')}
        >
          <Footsteps />
          Request dispatch
        </GraniteButton>
        <GraniteButton
          variant="secondary"
          size="large"
          onClick={() => setMode('edit')}
        >
          <ConstructSharp width="24px" height="24px" color="inherit" />
          Open repair ticket
        </GraniteButton>
      </div>
    </div>
  );
};

export default LocationHeader;
